import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const EndocrineStressCortisolCortisoneDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const cyp21a2 = getGenePalette(geneColors.CYP21A2);
  const cyp11b1 = getGenePalette(geneColors.CYP11B1);
  const hsd11b1 = getGenePalette(geneColors.HSD11B1);
  const srd5a1 = getGenePalette(geneColors.SRD5A1);
  const akr1d1 = getGenePalette(geneColors.AKR1D1);
  const akr1c2 = getGenePalette(geneColors.AKR1C2);
  const serpina6 = getGenePalette(geneColors.SERPINA6);
  const fkbp5 = getGenePalette(geneColors.FKBP5);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_224303)">
        <rect width={1024} height={1344} transform="translate(0 204)" fill="white" />
        <g id="endocrine-stress-diagram">
          <rect width={1024} height={1344} transform="translate(0 204)" fill="white" />
          <g id="lines">
            <path
              id="Vector_2"
              d="M727.6 406.654L735.191 403.877L728.991 398.692L727.6 406.654ZM842.521 270.329L842.97 269.792L841.896 268.894L841.447 269.431L841.984 269.88L842.521 270.329ZM731.642 401.822L732.179 402.271L842.521 270.329L841.984 269.88L841.447 269.431L731.105 401.372L731.642 401.822Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M582.6 583.654L590.191 580.877L583.991 575.692L582.6 583.654ZM697.521 447.329L697.97 446.792L696.896 445.894L696.447 446.431L696.984 446.88L697.521 447.329ZM586.642 578.822L587.179 579.271L697.521 447.329L696.984 446.88L696.447 446.431L586.105 578.372L586.642 578.822Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_4"
              d="M398.6 764.654L406.191 761.877L399.991 756.692L398.6 764.654ZM513.521 628.329L513.97 627.792L512.896 626.894L512.447 627.431L512.984 627.88L513.521 628.329ZM402.642 759.822L403.179 760.271L513.521 628.329L512.984 627.88L512.447 627.431L402.105 759.372L402.642 759.822Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_5"
              d="M685.018 767.61L685.002 759.527L678.01 763.582L685.018 767.61ZM604.697 627.727L604.346 627.122L603.135 627.824L603.486 628.43L604.092 628.079L604.697 627.727ZM681.857 762.16L682.462 761.809L604.697 627.727L604.092 628.079L603.486 628.43L681.251 762.511L681.857 762.16Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_6"
              d="M266 599.292L273 603.333V595.25L266 599.292ZM476.3 599.992H477V598.592H476.3V599.292V599.992ZM272.3 599.292V599.992L476.3 599.992V599.292V598.592L272.3 598.592V599.292Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_6">
            <path
              id="Vector_7"
              d="M266.7 612.592H266V613.992H266.7V613.292V612.592ZM477 613.292L470 609.25V617.333L477 613.292ZM266.7 613.292V613.992L470.7 613.992V613.292V612.592L266.7 612.592V613.292Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_8"
              d="M395.542 958.75L399.583 951.75L391.5 951.75L395.542 958.75ZM396.241 809.45L396.241 808.75L394.841 808.75L394.841 809.45L395.541 809.45L396.241 809.45ZM395.542 952.45L396.242 952.45L396.241 809.45L395.541 809.45L394.841 809.45L394.842 952.45L395.542 952.45Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_9"
              d="M175.042 958.75L179.083 951.75L171 951.75L175.042 958.75ZM175.741 809.45L175.741 808.75L174.341 808.75L174.341 809.45L175.041 809.45L175.741 809.45ZM175.042 952.45L175.742 952.45L175.741 809.45L175.041 809.45L174.341 809.45L174.342 952.45L175.042 952.45Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_10"
              d="M175.042 769.25L179.083 762.25L171 762.25L175.042 769.25ZM175.741 619.95L175.741 619.25L174.341 619.25L174.341 619.95L175.041 619.95L175.741 619.95ZM175.042 762.95L175.742 762.95L175.741 619.95L175.041 619.95L174.341 619.95L174.342 762.95L175.042 762.95Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_10">
            <text
              id="Line Label"
              transform="translate(345 1134.25) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={32.0293} y={16.086}>
                Undergoes{" "}
              </tspan>
              <tspan x={32.2812} y={40.086}>
                Sulphation
              </tspan>
            </text>
            <path
              id="Vector_11"
              d="M400.042 1134.25L404.083 1127.25L396 1127.25L400.042 1134.25ZM400.741 1010.95L400.741 1010.25L399.341 1010.25L399.341 1010.95L400.041 1010.95L400.741 1010.95ZM400.042 1127.95L400.742 1127.95L400.741 1010.95L400.041 1010.95L399.341 1010.95L399.342 1127.95L400.042 1127.95Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_11">
            <text
              id="Line Label_2"
              transform="translate(120 1134.25) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={22.0273} y={16.086}>
                Glucuronidase{" "}
              </tspan>
              <tspan x={38.3281} y={40.086}>
                Enzymes
              </tspan>
            </text>
            <path
              id="Vector_12"
              d="M175.042 1134.25L179.083 1127.25L171 1127.25L175.042 1134.25ZM175.741 1010.95L175.741 1010.25L174.341 1010.25L174.341 1010.95L175.041 1010.95L175.741 1010.95ZM175.042 1127.95L175.742 1127.95L175.741 1010.95L175.041 1010.95L174.341 1010.95L174.342 1127.95L175.042 1127.95Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_12">
            <path
              id="Vector_13"
              d="M690.542 963.75L694.583 956.75L686.5 956.75L690.542 963.75ZM691.241 805.45L691.241 804.75L689.841 804.75L689.841 805.45L690.541 805.45L691.241 805.45ZM690.542 957.45L691.242 957.45L691.241 805.45L690.541 805.45L689.841 805.45L689.842 957.45L690.542 957.45Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_13">
            <path
              id="Vector_14"
              d="M691.042 1441.25L695.083 1434.25L687 1434.25L691.042 1441.25ZM691.741 1259.95L691.741 1259.25L690.341 1259.25L690.341 1259.95L691.041 1259.95L691.741 1259.95ZM691.042 1434.95L691.742 1434.95L691.741 1259.95L691.041 1259.95L690.341 1259.95L690.342 1434.95L691.042 1434.95Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_14">
            <path
              id="Vector_15"
              d="M878.3 1259.95L383.7 1259.95"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="lines_15">
            <path
              id="Vector_16"
              d="M878.3 605.75L627 605.75"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="lines_16">
            <path
              id="Vector_17"
              d="M877.7 606.75L877.7 1258.55"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="lines_17">
            <path
              id="Vector_18"
              d="M383.042 1436.25L387.083 1429.25L379 1429.25L383.042 1436.25ZM383.741 1260.95L383.741 1260.25L382.341 1260.25L382.341 1260.95L383.041 1260.95L383.741 1260.95ZM383.042 1429.95L383.742 1429.95L383.741 1260.95L383.041 1260.95L382.341 1260.95L382.342 1429.95L383.042 1429.95Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_18">
            <text
              id="Line Label_3"
              transform="translate(636 1134.25) rotate(-90)"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={23.5273} y={16.086}>
                Glucuronidase{" "}
              </tspan>
              <tspan x={39.8281} y={40.086}>
                Enzymes
              </tspan>
            </text>
            <path
              id="Vector_19"
              d="M691.042 1134.25L695.083 1127.25L687 1127.25L691.042 1134.25ZM691.741 1007.95L691.741 1007.25L690.341 1007.25L690.341 1007.95L691.041 1007.95L691.741 1007.95ZM691.042 1127.95L691.742 1127.95L691.741 1007.95L691.041 1007.95L690.341 1007.95L690.342 1127.95L691.042 1127.95Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles">
            <rect width={120} height={28} transform="translate(662.5 411.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={662.953} y={431.198}>
                11-Deoxycortisol
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <rect width={137} height={28} transform="translate(321.5 773.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={321.586} y={793.198}>
                5&#x3b1;-Dihydrocortisol
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <rect width={137} height={28} transform="translate(106 773.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={106.086} y={793.198}>
                5&#x3b1;-Dihydrocortisol
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect width={137} height={28} transform="translate(615.5 773.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={615.695} y={793.198}>
                5&#x3b2;-Dihydrocortisol
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect width={139} height={28} transform="translate(628 1143.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={628.26} y={1163.38}>
                Urinary Excretion
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <rect width={139} height={28} transform="translate(331 1149.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={331.26} y={1169.38}>
                Urinary Excretion
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={139} height={28} transform="translate(105 1149.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={105.26} y={1169.38}>
                Urinary Excretion
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect width={187} height={56} transform="translate(283 1453.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={288.422} y={1472.7}>
                Modulates the HPA axis{" "}
              </tspan>
              <tspan x={289.219} y={1500.7}>
                (stress response system)
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={158} height={36} transform="translate(211 1368.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0em"
            >
              <tspan x={221.211} y={1382.34}>
                Regulates glucocorticoid{" "}
              </tspan>
              <tspan x={224.82} y={1398.34}>
                receptor (GR) sensitivity
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <rect width={103} height={20} transform="translate(711 1368.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_10"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0em"
            >
              <tspan x={715.596} y={1382.34}>
                Transport Protein
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <rect width={245} height={56} transform="translate(598 1453.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_11"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={603.383} y={1472.7}>
                Regulation of the bioavailability{" "}
              </tspan>
              <tspan x={659.695} y={1500.7}>
                of active cortisol
              </tspan>
            </text>
          </g>
          <g id="Report titles_12">
            <rect width={81} height={36} transform="translate(651.5 966.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_12"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={651.711} y={992.91}>
                5&#x3b2;-THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_13">
            <rect width={81} height={36} transform="translate(354.5 966.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_13"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={354.594} y={992.91}>
                5&#x3b1;-THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <rect width={81} height={36} transform="translate(355 967.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_14"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={355.094} y={993.41}>
                5&#x3b1;-THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_15">
            <rect width={42} height={36} transform="translate(154 967.25)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_15"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={154} y={993.41}>
                THE
              </tspan>
            </text>
          </g>
          <g id="Report titles_16">
            <rect width={116} height={28} transform="translate(496.5 591.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_16"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={496.914} y={611.198}>
                Cortisol (Active)
              </tspan>
            </text>
          </g>
          <g id="Report titles_17">
            <rect width={140} height={28} transform="translate(119 591.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_17"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={119.438} y={611.198}>
                Cortisone (Inactive)
              </tspan>
            </text>
          </g>
          <g id="gene-CYP21A2" {...geneGroupProps("CYP21A2", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M722.5 307.75C722.5 305.541 724.291 303.75 726.5 303.75H845.5C847.709 303.75 849.5 305.541 849.5 307.75V343.75C849.5 345.959 847.709 347.75 845.5 347.75H726.5C724.291 347.75 722.5 345.959 722.5 343.75V307.75Z"
                fill={cyp21a2.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={738.891} y={333.91}>
                  CYP21A2
                </tspan>
              </text>
              <path
                id="*_3"
                d="M860.248 300.156V302.574L856.318 302.445L858.564 305.684L856.361 306.98L854.374 303.481L852.387 306.98L850.184 305.684L852.43 302.445L848.5 302.574L848.5 300.156L852.43 300.285L850.184 297.046L852.387 295.75L854.374 299.249L856.361 295.75L858.564 297.046L856.318 300.285L860.248 300.156Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="cyp21a2"
              groupId="gene-snps"
              genePalette={cyp21a2}
              startX={730.5}
              startY={349.75}
              snpCount={getGeneSnpCount("CYP21A2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP11B1" {...geneGroupProps("CYP11B1", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M580.5 491.75C580.5 489.541 582.291 487.75 584.5 487.75H693.5C695.709 487.75 697.5 489.541 697.5 491.75V527.75C697.5 529.959 695.709 531.75 693.5 531.75H584.5C582.291 531.75 580.5 529.959 580.5 527.75V491.75Z"
                fill={cyp11b1.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={596.824} y={517.91}>
                  CYP11B1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp11b1"
              groupId="gene-snps_2"
              genePalette={cyp11b1}
              startX={588.5}
              startY={533.75}
              snpCount={getGeneSnpCount("CYP11B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD11B1" {...geneGroupProps("HSD11B1", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M302 530.25C302 528.041 303.791 526.25 306 526.25H416C418.209 526.25 420 528.041 420 530.25V566.25C420 568.459 418.209 570.25 416 570.25H306C303.791 570.25 302 568.459 302 566.25V530.25Z"
                fill={hsd11b1.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={318.391} y={556.41}>
                  HSD11B1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="hsd11b1"
              groupId="gene-snps_3"
              genePalette={hsd11b1}
              startX={310}
              startY={572.25}
              snpCount={getGeneSnpCount("HSD11B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A1" {...geneGroupProps("SRD5A1", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M404.5 677.75C404.5 675.541 406.291 673.75 408.5 673.75H512.5C514.709 673.75 516.5 675.541 516.5 677.75V713.75C516.5 715.959 514.709 717.75 512.5 717.75H408.5C406.291 717.75 404.5 715.959 404.5 713.75V677.75Z"
                fill={srd5a1.lozengeFill}
              />
              <text
                id="gene-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={420.516} y={703.91}>
                  SRD5A1
                </tspan>
              </text>
              <path
                id="*_4"
                d="M527.248 670.156V672.574L523.318 672.445L525.564 675.684L523.361 676.98L521.374 673.481L519.387 676.98L517.184 675.684L519.43 672.445L515.5 672.574L515.5 670.156L519.43 670.285L517.184 667.046L519.387 665.75L521.374 669.249L523.361 665.75L525.564 667.046L523.318 670.285L527.248 670.156Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="srd5a1"
              groupId="gene-snps_4"
              genePalette={srd5a1}
              startX={412.5}
              startY={719.75}
              snpCount={getGeneSnpCount("SRD5A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1D1" {...geneGroupProps("AKR1D1", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M119 677.75C119 675.541 120.791 673.75 123 673.75H224C226.209 673.75 228 675.541 228 677.75V713.75C228 715.959 226.209 717.75 224 717.75H123C120.791 717.75 119 715.959 119 713.75V677.75Z"
                fill={akr1d1.lozengeFill}
              />
              <text
                id="gene-label_9"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={135.098} y={703.91}>
                  AKR1D1
                </tspan>
              </text>
              <path
                id="*_5"
                d="M238.748 670.156V672.574L234.818 672.445L237.064 675.684L234.861 676.98L232.874 673.481L230.887 676.98L228.684 675.684L230.93 672.445L227 672.574L227 670.156L230.93 670.285L228.684 667.046L230.887 665.75L232.874 669.249L234.861 665.75L237.064 667.046L234.818 670.285L238.748 670.156Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1d1"
              groupId="gene-snps_5"
              genePalette={akr1d1}
              startX={127}
              startY={719.75}
              snpCount={getGeneSnpCount("AKR1D1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1D1_2" {...geneGroupProps("AKR1D1", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M607.5 680.75C607.5 678.541 609.291 676.75 611.5 676.75H712.5C714.709 676.75 716.5 678.541 716.5 680.75V716.75C716.5 718.959 714.709 720.75 712.5 720.75H611.5C609.291 720.75 607.5 718.959 607.5 716.75V680.75Z"
                fill={akr1d1.lozengeFill}
              />
              <text
                id="gene-label_10"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={623.598} y={706.91}>
                  AKR1D1
                </tspan>
              </text>
              <path
                id="*_6"
                d="M727.248 673.156V675.574L723.318 675.445L725.564 678.684L723.361 679.98L721.374 676.481L719.387 679.98L717.184 678.684L719.43 675.445L715.5 675.574L715.5 673.156L719.43 673.285L717.184 670.046L719.387 668.75L721.374 672.249L723.361 668.75L725.564 670.046L723.318 673.285L727.248 673.156Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1d1-2"
              groupId="gene-snps_6"
              genePalette={akr1d1}
              startX={615.5}
              startY={722.75}
              snpCount={getGeneSnpCount("AKR1D1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1C2" {...geneGroupProps("AKR1C2", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M633.5 871.75C633.5 869.541 635.291 867.75 637.5 867.75H743.5C745.709 867.75 747.5 869.541 747.5 871.75V907.75C747.5 909.959 745.709 911.75 743.5 911.75H637.5C635.291 911.75 633.5 909.959 633.5 907.75V871.75Z"
                fill={akr1c2.lozengeFill}
              />
              <text
                id="gene-label_11"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={649.566} y={897.91}>
                  AKR1C2
                </tspan>
              </text>
              <path
                id="*_7"
                d="M758.248 864.156V866.574L754.318 866.445L756.564 869.684L754.361 870.98L752.374 867.481L750.387 870.98L748.184 869.684L750.43 866.445L746.5 866.574L746.5 864.156L750.43 864.285L748.184 861.046L750.387 859.75L752.374 863.249L754.361 859.75L756.564 861.046L754.318 864.285L758.248 864.156Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c2"
              groupId="gene-snps_7"
              genePalette={akr1c2}
              startX={641.5}
              startY={913.75}
              snpCount={getGeneSnpCount("AKR1C2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SERPINA6" {...geneGroupProps("SERPINA6", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M623 1300.25C623 1298.04 624.791 1296.25 627 1296.25H756C758.209 1296.25 760 1298.04 760 1300.25V1336.25C760 1338.46 758.209 1340.25 756 1340.25H627C624.791 1340.25 623 1338.46 623 1336.25V1300.25Z"
                fill={serpina6.lozengeFill}
              />
              <text
                id="gene-label_12"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={639.035} y={1326.41}>
                  SERPINA6
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="serpina6"
              groupId="gene-snps_8"
              genePalette={serpina6}
              startX={631}
              startY={1342.25}
              snpCount={getGeneSnpCount("SERPINA6", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1C2_2" {...geneGroupProps("AKR1C2", onGeneClick)}>
            <g id="gene-lozenge_13">
              <path
                d="M338.5 874.75C338.5 872.541 340.291 870.75 342.5 870.75H448.5C450.709 870.75 452.5 872.541 452.5 874.75V910.75C452.5 912.959 450.709 914.75 448.5 914.75H342.5C340.291 914.75 338.5 912.959 338.5 910.75V874.75Z"
                fill={akr1c2.lozengeFill}
              />
              <text
                id="gene-label_13"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={354.566} y={900.91}>
                  AKR1C2
                </tspan>
              </text>
              <path
                id="*_8"
                d="M463.248 867.156V869.574L459.318 869.445L461.564 872.684L459.361 873.98L457.374 870.481L455.387 873.98L453.184 872.684L455.43 869.445L451.5 869.574L451.5 867.156L455.43 867.285L453.184 864.046L455.387 862.75L457.374 866.249L459.361 862.75L461.564 864.046L459.318 867.285L463.248 867.156Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c2-2"
              groupId="gene-snps_9"
              genePalette={akr1c2}
              startX={346.5}
              startY={916.75}
              snpCount={getGeneSnpCount("AKR1C2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-FKBP5" {...geneGroupProps("FKBP5", onGeneClick)}>
            <g id="gene-lozenge_14">
              <path
                d="M332 1303.25C332 1301.04 333.791 1299.25 336 1299.25H429C431.209 1299.25 433 1301.04 433 1303.25V1339.25C433 1341.46 431.209 1343.25 429 1343.25H336C333.791 1343.25 332 1341.46 332 1339.25V1303.25Z"
                fill={fkbp5.lozengeFill}
              />
              <text
                id="gene-label_14"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={348.363} y={1329.41}>
                  FKBP5
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fkbp5"
              groupId="gene-snps_10"
              genePalette={fkbp5}
              startX={340}
              startY={1345.25}
              snpCount={getGeneSnpCount("FKBP5", expectedSnps, geneColors)}
            />
          </g>
          <g id="Cofactor_3">
            <g id="Frame 471">
              <g id="diamond_2">
                <text
                  id="label"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={254.881} y={502.767}>
                    NADPH
                  </tspan>
                </text>
                <g id="Vector_20">
                  <mask id="path-126-inside-2_18293_224303" fill="white">
                    <path d="M278 468L308 482.545V513.455L278 528L248 513.455V482.545L278 468Z" />
                  </mask>
                  <path
                    d="M278 468L308 482.545V513.455L278 528L248 513.455V482.545L278 468Z"
                    stroke="#1A1A1A"
                    strokeWidth={2.8}
                    mask="url(#path-126-inside-2_18293_224303)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="gene-AKR1C2_3" {...geneGroupProps("AKR1C2", onGeneClick)}>
            <g id="gene-lozenge_15">
              <path
                d="M110 874.75C110 872.541 111.791 870.75 114 870.75H220C222.209 870.75 224 872.541 224 874.75V910.75C224 912.959 222.209 914.75 220 914.75H114C111.791 914.75 110 912.959 110 910.75V874.75Z"
                fill={akr1c2.lozengeFill}
              />
              <text
                id="gene-label_15"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={126.066} y={900.91}>
                  AKR1C2
                </tspan>
              </text>
              <path
                id="*_9"
                d="M234.748 867.156V869.574L230.818 869.445L233.064 872.684L230.861 873.98L228.874 870.481L226.887 873.98L224.684 872.684L226.93 869.445L223 869.574L223 867.156L226.93 867.285L224.684 864.046L226.887 862.75L228.874 866.249L230.861 862.75L233.064 864.046L230.818 867.285L234.748 867.156Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c2-3"
              groupId="gene-snps_11"
              genePalette={akr1c2}
              startX={118}
              startY={916.75}
              snpCount={getGeneSnpCount("AKR1C2", expectedSnps, geneColors)}
            />
          </g>
          <g id="Report titles_18">
            <rect width={147} height={28} transform="translate(772 242.75)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_18"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={772.266} y={262.198}>
                17-OH Progesterone
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgEndocrineStressCortisolCortisoneDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1344}
    viewBox="0 204 1024 1344"
    fill="none"
    {...props}
  >
    <EndocrineStressCortisolCortisoneDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_224303">
        <rect width={1024} height={1548} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_224303">
        <rect width={1024} height={1344} fill="white" transform="translate(0 204)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEndocrineStressCortisolCortisoneDiagram;
